import { useCallback } from 'react'
import { useFormikContext } from 'formik'
import { IAddOpportunityFormModel } from '@user/components/Opportunities/AddOpportunityPage/typings'
import { ISalesFunnelStage } from '@user/store/salesFunnel'
type Props = {
  name: string
  onClosedWonChange: (isClosedWon: boolean, isClosedLost: boolean) => void
  required?: boolean
}
export function useHandlers(props: Props) {
  const { name, onClosedWonChange, required } = props
  const { setFieldValue, setFieldTouched } =
    useFormikContext<IAddOpportunityFormModel>()

  const handleBlur = useCallback(() => {
    if (required == undefined || required == true) setFieldTouched(name, true)
  }, [name, setFieldTouched, required])

  const handelChange = useCallback((value: ISalesFunnelStage | null) => {
    onClosedWonChange(false, false)
    setFieldValue('opportunityStageName', value ? value.name : '')
    if (value && value.name == 'Closed/Won') {
      onClosedWonChange(true, false)
    }
    if (value && value.name == 'Closed/Lost') {
      onClosedWonChange(false, true)
    }
    setFieldValue(name, value?.id)
  }, [])
  return {
    handleBlur,
    handelChange,
  }
}
